import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataPesertaWebinar = 'data-peserta-pelatihan-webinar';
const getPelatihan = 'workshop-pelatihan';
const getSertifikat = 'data-peserta-pelatihan-webinar/pengaturan-sertifikat/';
const detailDataPeserta = 'data-peserta-pelatihan';
const exportSKP = 'skp-export';
const downloadSKP = 'data-peserta-pelatihan-export';
const putSertifikat = 'data-peserta-pelatihan/upload-sertifikat/';
const getDataDokumen = 'data-peserta-pelatihan/dokumen-pendukung-peserta-pelatihan/';
const ProsesAdministrasiUrl = 'data-peserta-pelatihan/proses-administrasi/';
const putStatusPembatalan = 'data-peserta-pelatihan/ubah-status-pembatalan/';

class DataPesertaWebinarService {
    getDataPeserta(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            status_pembayaran: "umum",
            filter: filter
        }
        return axios.get(
            API_URL + getDataPesertaWebinar,
            {
                params: data,
                headers: authHeader()
            });
    }

    
    getDataPesertaOffline(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            filter: filter
        }
        return axios.get(
            API_URL + detailDataPeserta,
            {
                params: data,
                headers: authHeader()
            });
    }

    getDataPesertaSkp(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            status_pembayaran: "lunas_mengikuti",
            filter: filter
        }
        return axios.get(
            API_URL + detailDataPeserta,
            {
                params: data,
                headers: authHeader()
            });
    }

    
    getDataPesertaOfflineSkp(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            status_pembayaran: "lunas_mengikuti",
            filter: filter
        }
        return axios.get(
            API_URL + detailDataPeserta,
            {
                params: data,
                headers: authHeader()
            });
    }

    getPelatihan() {
        return axios.get(
            API_URL + getPelatihan, {
            headers: authHeader()
        });

    }

    getSertifikat(id_pelatihan_peserta) {
        return axios.get(
            API_URL + getSertifikat + id_pelatihan_peserta, {
            headers: authHeader()
        });

    }

    detailDataPeserta(idPelatihanPeserta) {
        return axios
            .get(
                API_URL + detailDataPeserta + "/" + idPelatihanPeserta,
                { headers: authHeader() }
            );
    }

    exportSKP() {
        return axios.get(API_URL + exportSKP, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }

    downloadSKP(pelatihan, periode) {
        return axios.get(
            API_URL + downloadSKP + '?idWorkshopPelatihan=' + pelatihan + '&periode=' + periode,
            {
                headers: authHeader(),
                responseType: 'blob'
            });
    }

    putSertifikat(formData) {
        var headers = authHeader(); 
        var form = new FormData();
        form.append('statusPenerimaan', formData.status_penerimaan);

        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        return axios
        .put(
            API_URL + putSertifikat + formData.id_pelatihan_peserta, form,
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() }  }
        );
    }

    getDataDokumen(idPelatihanPeserta) {
        return axios
            .get(
                API_URL + getDataDokumen + idPelatihanPeserta,
                { headers: authHeader() }
            );
    }

    putSendProsesAdministrasi(formProsesAdministrasi) {
        var headers = authHeader();

        return axios
        .put(
            API_URL + ProsesAdministrasiUrl + formProsesAdministrasi.idPelatihanPeserta,
            formProsesAdministrasi,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } }
        );
    }

    putStatusPembatalan(formData) {        
        return axios.put(API_URL + putStatusPembatalan + formData.idPelatihanPeserta, 
            formData,
        {
            headers: authHeader() 
        });
    }

}

export default new DataPesertaWebinarService();